import { QuestionDrawingPreference } from "../types";
import { PassRequirementValue } from "./types";

export const OrderPreferenceOptions = [
  {
    name: "Prefer new questions",
    value: QuestionDrawingPreference.PreferNewQuestions,
  },
  {
    name: "Prefer previously failed questions",
    value: QuestionDrawingPreference.PreferWrongQuestions,
  },
  {
    name: "No preference",
    value: QuestionDrawingPreference.PreferNewOrWrongQuestions,
  },
];

export const PassRequirementOptions = [
  { name: "Require Assessment", value: PassRequirementValue.Assessment },
  { name: "Require Review of Content", value: PassRequirementValue.Review },
  {
    name: "Require Assessment and Review of Content",
    value: PassRequirementValue.AssessmentAndReview,
  },
  {
    name: "Require Assessment or Review of Content",
    value: PassRequirementValue.AssessmentOrReview,
  },
];

export const hints = {
  accumulateHint: `If checked, correct answers will accumulate across assessments; this will make it easier for learners to complete the assessment because they don't need to start over from 0 in subsequent attempts.`,
  mistakesAllowedHint: `This option sets the number of mistakes it takes for a learner to fail this assessment and be asked to review the lesson (again). Select "infinity" for an unlimited number of attempts.`,
  numRequiredCorrectHint: `Choose how many correct answers are required to pass this assessment. You can only require as many correct answers as there are questions in this assessment.`,
  preferenceHint: `This option sets the order in which new questions are drawn during the assessment.`,
  randomizeHint: `If checked, questions will be asked in a randomised order. Otherwise, they will appear in the order given below.`,
  requirementHint: `This option determines what the learner must do before we consider them to have passed this unit.`,
  showCorrectHint: `If checked, a learner reviewing an assessment they have taken will be shown the hints for and correct answers to the questions they took.`,
};
